import React, { createContext, useMemo, useState, useContext } from "react"

export const TableFormLaunchContext = createContext(null)

export const TableFormLaunchContextProvider = ({ children }) => {
  const [bUpdateJustityModalIsOpen, setBUpdateJustityModalIsOpen] = useState(false)
  const [oLaunchs, setOLaunchs] = useState(null) // form data
  const [oAnalyte, setOAnalyte] = useState(null)
  const [oRunDetails, setORunDetails] = useState(null)
  const [disableEditMode, setDisableEditMode] = useState(() => () => {})
  const [oRunDelete, setORunDelete] = useState(null)
  const [oLastRun, setOLastRun] = useState(null)
  const [oLaunchObservation, setOLaunchObservation] = useState(null)

  const value = useMemo(() => {
    return {
      bUpdateJustityModalIsOpen,
      setBUpdateJustityModalIsOpen,
      oLaunchs,
      setOLaunchs,
      oAnalyte,
      setOAnalyte,
      oRunDetails,
      setORunDetails,
      disableEditMode,
      setDisableEditMode,
      oRunDelete,
      setORunDelete,
      oLastRun,
      setOLastRun,
      oLaunchObservation,
      setOLaunchObservation
    }
  }, [bUpdateJustityModalIsOpen, oLaunchs, oAnalyte, oRunDetails, disableEditMode, oRunDelete, oLastRun, oLaunchObservation])

  return (
    <TableFormLaunchContext.Provider value={value}>
      {children}
    </TableFormLaunchContext.Provider>
  )
}

export default TableFormLaunchContext

export function useTableFormLaunch() {
  return useContext(TableFormLaunchContext)
}
